@use '../../scss/utility/functions' as utility;

@use './counter-vars';
@use './counter-common';

:host {
  @include counter-vars.wb-counter-vars;
  @include counter-common.wb-counter;
}

:host([variant='primary']) {
  @include counter-vars.wb-counter-primary-vars;
}

:host([variant='secondary']) {
  @include counter-vars.wb-counter-secondary-vars;
}

:host([variant='tertiary']) {
  @include counter-vars.wb-counter-tertiary-vars;
}

:host([variant='success']) {
  @include counter-vars.wb-counter-success-vars;
}

:host([variant='warning']) {
  @include counter-vars.wb-counter-warning-vars;
}

:host([variant='error']) {
  @include counter-vars.wb-counter-error-vars;
}

:host([data-digits='1']) {
  @include counter-vars.wb-counter-single-vars;
}

:host([data-digits='2']) {
  @include counter-vars.wb-counter-double-vars;
}

:host([data-digits='3']) {
  @include counter-vars.wb-counter-triple-vars;
}

:host(:not([data-digits='1']):not([data-digits='2']):not([data-digits='3'])) {
  @include counter-vars.wb-counter-continuous-vars;
  @include counter-common.wb-counter-continuous;
}
